import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DoctorDataModel} from '../../../../models/doctors/doctor-data.model';
import {StaticDataService} from '../../../../services/static-data.service';
import {DoctorsService} from '../../../../services/doctors.service';
import {OfficeLocationsService} from '../../../configuration/office-locations/office-locations.service';
import {Globals} from '../../../../globals';
import {UntypedFormControl} from '@angular/forms';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';
import {ReportFinancialSnapshotFilterModel} from '../../models/ReportFinancialSnapshotFilterModel.model';
import {MatRadioChange} from '@angular/material/radio';
import Utils from '../../Utils/utils';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DataRangesEnum} from '../../../../models/enum/Date-Ranges.enum';
import {ClientLocationDataModel} from '../../../../models/clients/client-location-data.model';

interface OrderByOption {
  value: string;
  viewValue: string;
}


@Component({
  standalone: false,
  selector: 'app-report-financial-snapshot-filters',
  templateUrl: './report-financial-snapshot-filters.component.html',
  styleUrls: ['./report-financial-snapshot-filters.component.scss']
})
export class ReportFinancialSnapshotFiltersComponent implements OnInit {
  selectedDateRanges: EnumValidValueItemModel;
  doctorSelected: DoctorDataModel;
  doctor = new UntypedFormControl();
  selectedSnapshotType: any;
  selectedOrderByOption: any;
  startDate: any;
  endDate: any;
  isDateRangeDefined: boolean = false;
  isCurrentMonth: boolean = false;
  isAsc: boolean = true;
  snapShotReport: boolean = true;
  checkboxSnapShotReport = new UntypedFormControl(true);
  checkboxShowActiveDoctors = new UntypedFormControl(false);
  isInteractiveReport: boolean = true;
  showInactive: boolean = false;
  isReportForProvide: boolean = false;
  clientList: any;
  selectedClient: any;
  selectedSnapShotOrderBy: any;
  selectedDoctor: DoctorDataModel;
  selectedProviders: DoctorDataModel[] = [];

  selectedClientLocation: ClientLocationDataModel[] = [];
  locationList: ClientLocationDataModel[];
  doctorPredicate: (data: DoctorDataModel) => string;


  filterDateRangesEnums: EnumValidValueItemModel[] = [];
  filterRSFSnapshotTypeEnums: EnumValidValueItemModel[] = [];
  private reportFinancialSnapshotFilterModel: ReportFinancialSnapshotFilterModel;
  @Output() newItemEvent = new EventEmitter<any>();
  @Output() onChecked: EventEmitter<any> = new EventEmitter<any>();
  @Input() isSnapShotReport = false;
  @Input() isDailySnapShot = false;


  orderByOption: OrderByOption[] = [
    {value: '00000001-1000-0000-0000-100000000001', viewValue: 'Description'},
    {value: '00000001-1000-0000-0000-100000000002', viewValue: 'Debit'},
    {value: '00000001-1000-0000-0000-100000000003', viewValue: 'Debit %'},
    {value: '00000001-1000-0000-0000-100000000004', viewValue: 'Credit'},
    {value: '00000001-1000-0000-0000-100000000005', viewValue: 'Credit %'},
  ];

  orderByOptionDaily: OrderByOption[] = [
    {value: '00000001-1000-0000-0000-100000000006', viewValue: 'Name'}
  ];

  constructor(public staticDataService: StaticDataService,
              public doctorService: DoctorsService,
              public locService: OfficeLocationsService,
              public globals: Globals,
              private snackBar: MatSnackBar) {}

  ngOnInit(): void {

    this.doctorPredicate = (data: DoctorDataModel) => {
      if (data.dataContact === undefined) {
        return '';
      }
      return 'Dr. ' + data.dataContact.FirstName + ' ' + data.dataContact.LastName;
    };

    this.loadServiceData();

  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }


  onDoctorSelect(doctor: DoctorDataModel, event: any) {
    if (event.isUserInput) {
      this.doctorSelected = doctor;
    }
  }


  loadServiceData()
  {
    this.locService.getClients().subscribe(data => {
    this.clientList = data;
    if (this.clientList.length > 0) {
        // Try to locate current users client
        this.selectedClient = this.clientList.find(p => p.TDOCID.toString() === this.globals.TDOCID);
      }
    }, err => {
      console.log(err);
      // this.isBusy = false;
    });
    this.filterDateRangesEnums = this.staticDataService.getValidValueItemsByValidValueName('enumIOFilterDateRanges');
    this.filterRSFSnapshotTypeEnums = this.staticDataService.getValidValueItemsByValidValueName('enumRSFSnapshotBreakdownType');

    // set default parameters
    this.selectedDateRanges  = this.filterDateRangesEnums.find(p => p.ValidValueItemId.toString() === DataRangesEnum.Today); // set TODAY
    this.selectedSnapShotOrderBy = this.orderByOptionDaily.find(p => p.value.toString() === '00000001-1000-0000-0000-100000000006');
    this.selectedOrderByOption = this.orderByOption.find(p => p.value.toString() === '00000001-1000-0000-0000-100000000001'); // BY NAME
    this.selectedSnapshotType = this.filterRSFSnapshotTypeEnums.find(p => p.ValidValueItemId.toString() === '00000280-1000-0000-0000-000000000001');
    this.doctor.setValue(this.staticDataService.currentLocationDoctors[0]);
    this.doctorSelected  = this.staticDataService.currentLocationDoctors[0];
    this.setDatesRanges();

  }
  onChangeSnapshotType(event) {
    this.selectedSnapshotType = event.value;
  }

  onChangeOrderByOption(event) {
    this.selectedOrderByOption = event.value;
  }
  onChangeOrderByOptionDaily(event){
    this.selectedSnapShotOrderBy = event.value;
  }

  onChangeDateRanges(event) {
    this.selectedDateRanges = event.value;
    this.setDatesRanges();
  }
  setDatesRanges(){
    this.isDateRangeDefined = true;
    this.isCurrentMonth = false;
    const {startDate, endDate, isCurrentMonth} = Utils.getDataRange(this.selectedDateRanges.ValidValueItemId);
    this.startDate = startDate;
    this.endDate = endDate;
    this.isCurrentMonth = isCurrentMonth;
  }

  onDoctorsSelected(event) {
    if (event.isUserInput) {
      this.selectedProviders = event.value as DoctorDataModel[];
    }
  }

  sendFilterToParent() {
    if (this.isSnapShotReport !== true) {
      this.handleRegularSnapshot();
    } else {
      this.handleSnapShotReport();
    }
  }

  private handleRegularSnapshot() {
    if (
      this.selectedProviders.length  === 0 ||
      this.selectedOrderByOption === undefined ||
      this.selectedSnapshotType === undefined ||
      this.selectedDateRanges === undefined
    ) {
      return;
    }
    this.reportFinancialSnapshotFilterModel = new ReportFinancialSnapshotFilterModel();
    this.reportFinancialSnapshotFilterModel.ProvidersId = this.selectedProviders.filter(o => o.DoctorId !== undefined).map(x => x.DoctorId);
    this.reportFinancialSnapshotFilterModel.isCurrentMonth = this.isCurrentMonth;
    this.reportFinancialSnapshotFilterModel.TypeId = this.selectedSnapshotType.ValidValueItemId;
    this.reportFinancialSnapshotFilterModel.initialDate = this.startDate;
    this.reportFinancialSnapshotFilterModel.endDate = this.endDate;
    this.reportFinancialSnapshotFilterModel.isAsc = this.isAsc;
    this.reportFinancialSnapshotFilterModel.OrderBy = this.selectedOrderByOption.value;
    this.newItemEvent.emit(this.reportFinancialSnapshotFilterModel);
  }

  private handleSnapShotReport() {
    if (this.isReportForProvide) {
      if (this.doctorSelected === undefined) {
        return;
      }
      this.reportFinancialSnapshotFilterModel.isProvider = true;
      this.reportFinancialSnapshotFilterModel.PracticeId = null;
    } else {
      if (this.selectedClient === undefined) {
        return;
      }
      this.reportFinancialSnapshotFilterModel.PracticeId = this.selectedClient.TDOCID;
      this.reportFinancialSnapshotFilterModel.isProvider = false;
    }
    this.reportFinancialSnapshotFilterModel.isCurrentMonth = this.isCurrentMonth;
    this.reportFinancialSnapshotFilterModel.initialDate = this.startDate;
    this.reportFinancialSnapshotFilterModel.endDate = this.endDate;
    this.reportFinancialSnapshotFilterModel.isAsc = this.isAsc;
    this.reportFinancialSnapshotFilterModel.showInactive = this.showInactive;
    this.reportFinancialSnapshotFilterModel.isInteractiveReport = this.isInteractiveReport;
    this.reportFinancialSnapshotFilterModel.OrderBy = this.selectedSnapShotOrderBy.value;
    this.reportFinancialSnapshotFilterModel.dateRange = this.isDailySnapShot ? 'Today' : this.selectedDateRanges.ItemDisplayValue;
    this.newItemEvent.emit(this.reportFinancialSnapshotFilterModel);
  }

  radioChange(event: MatRadioChange) {
    event.value === 'true' ? this.isAsc = true : this.isAsc = false;
  }

  radioChangeReportFor(event: MatRadioChange) {
    event.value === 'true' ? this.isReportForProvide = true : this.isReportForProvide = false;
  }

  toggle(event: MatCheckboxChange){
    this.isInteractiveReport = event.source.checked;
    this.onChecked.emit(event.source.checked);
  }
  showInactiveDoc(event: MatCheckboxChange){
    this.showInactive = event.source.checked;

  }
  onChangeClient(event) {
    this.selectedClient = event.value;
  }


  onChangeClientLocation(event){
    if (event.isUserInput) {
      this.selectedClientLocation = event.value as ClientLocationDataModel[];
    }
  }


  UserDefined() {
    // set User Defined parameters
    this.selectedDateRanges  = this.filterDateRangesEnums.find(p => p.ValidValueItemId.toString() === DataRangesEnum.UserDefined);
  }



}
